<template>
  <div class="dialog-body">
    <el-dialog
      v-if="dialogVisible"
      title="仓单解冻提示"
      align="center"
      :visible.sync="dialogVisible"
      append-to-body
      width="50%"
      ref="dialogRef"
    >
      <div class="result">
        <el-form>
          <el-form-item label="目前库存：" :label-width="formLabelWidth">
            <el-input v-model="form.stockQuantity" disabled></el-input>
          </el-form-item>
        </el-form>
        <el-row :gutter="24">
          <el-col :span="24" v-if="isSatisfyNeeds">
            <span style="text-align: center; display: block"
              >已满足安全库存要求，可以发起解冻申请</span
            >
          </el-col>
          <el-col :span="24" v-else>
            <span style="text-align: center; display: block"
              >在库库存小于安全库存，请先添加库存</span
            >
          </el-col>
        </el-row>
      </div>
      <FileTable ref="fileTableRef" :isShowDownBtn="isShowDownBtn" :attachments="attachments" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSure" v-if="isSatisfyNeeds">确认申请</el-button>
        <el-button @click="handleClose">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import FileTable from '@/components/business/FileTable/index.vue';
  import superviseBillApi from '@/api/park/superviseBill';
  export default {
    name: 'ApplicationUnfreezingDialog',
    props: ['selectData'],
    data() {
      return {
        dialogVisible: false,
        form: {
          stockQuantity: null,
          safeStockQuantity: null,
          id: null,
        },
        formLabelWidth: '100px',
        tableData: [],
        baseFormData: {},
        attachments: [],
        billNo: '',
        isShowDownBtn: false,
        loading: false,
        isSatisfyNeeds: true,
      };
    },
    methods: {
      // 打开弹窗
      openDialog() {
        this.dialogVisible = true;
      },
      // 关闭弹窗
      handleClose() {
        this.dialogVisible = false;
      },
      // 确认申请
      async handleSure() {
        // 1.表单数据
        const baseFormData = this.form;
        // 2.附件
        const attachments = this.attachments;
        const postData = {
          ...baseFormData,
          attachments,
          companyCode: this.userInfo.companyCode,
          departmentCode: this.userInfo.departmentCode,
        };
        console.log(postData, 'postData');
        const { data } = await this.$axios.post(superviseBillApi.BILL_UNFROZE, postData);
        console.log(data, '申请冻结返回值');
        if (data.code == 0) {
          this.$message.success('提交成功，请等待审批');
          this.dialogVisible = false;
          location.reload();
        } else {
          this.$message.error(data.msg);
        }
      },
      // 判断是否满足要求
      judgeNeeds() {
        if (this.form.stockQuantity < this.form.safeQuantity) {
          this.isSatisfyNeeds = false;
        } else {
          this.isSatisfyNeeds = true;
        }
      },
      async initForm() {
        const { data } = await this.$axios.post(
          `${superviseBillApi.APPROVAL_QUERY_STOCK}/${this.billNo}`
        );
        console.log(data, '审批库存查询');
        if (data.code == 0) {
          this.form.stockQuantity = data.data.stockQuantity;
          this.form.safeStockQuantity = data.data.safeStockQuantity;
          this.judgeNeeds();
        } else {
          this.$message.error('查询库存失败');
        }
      },
    },
    comments: {
      FileTable,
    },
    watch: {
      selectData: {
        handler(val) {
          this.selectData = val;
          this.billNo = val.billNo;
          this.form.id = this.selectData.id;
          this.initForm();
        },
        immediate: false,
      },
    },
  };
</script>

<style scoped>
  ::v-deep .el-dialog__footer {
    text-align: center;
  }

  .el-dialog .el-dialog__body {
    justify-content: center;
    align-items: center;
  }
  .sirui-table {
    width: 500px;
    margin-top: -50px;
  }
  .dialog-body {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .el-select {
    width: 320px;
  }
  .result {
    padding: 20px 100px 20px 100px;
  }

  ::v-deep .el-dialog__footer {
    text-align: center;
  }
</style>
